import { ButtonProps, Icon } from "@chakra-ui/react";
import { useState } from "react";
import { FiArrowUpRight } from "react-icons/fi";
import { LuBraces } from "react-icons/lu";

import { NavButton, NavButtonDirection } from "./nav-button";

import { BUILDER_HUB_URL } from "@/constants/shared";

export const BuildOnPlumeButton = ({
  direction,
  buttonStyles = {},
}: {
  direction?: NavButtonDirection;
  buttonStyles?: ButtonProps;
}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <NavButton
      href={BUILDER_HUB_URL}
      color="fg.muted"
      target="_blank"
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      bgColor={hovered ? "bg.muted" : "bg"}
      position="relative"
      pl={3}
      pr={5}
      {...buttonStyles}
      direction={direction}
    >
      <LuBraces />
      Build on Plume
      <Icon
        position="absolute"
        right={1}
        visibility={hovered ? "visible" : "hidden"}
        boxSize={4}
      >
        <FiArrowUpRight />
      </Icon>
    </NavButton>
  );
};
